import { ac } from '../actions'

export const ENABLE_SCORLLING = 'ENABLE_SCROLLING'
export const DISABLE_SCRROLLING = 'DISABLE_SCROLLING'

export const enableScrolling = () => ac(ENABLE_SCORLLING)
export const disableScrolling = () => ac(DISABLE_SCRROLLING)
